<ng-container *ngFor="let w of widgets" axf-widget-renderer [widget]="w" [parent]="this"  [mode]="'view'" [rIndex]="rIndex">
</ng-container>